import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const WelcomeLetter: React.FC = () => {
  const [showLetter, setShowLetter] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Show letter only on mobile
    const isMobile = window.innerWidth < 768; // md breakpoint
    
    if (isMobile) {
      setShowLetter(true);
    }
  }, []);

  const handleOpenLetter = () => {
    setIsOpen(true);
    // Hide letter after animation
    setTimeout(() => {
      setShowLetter(false);
    }, 3800);
  };

  if (!showLetter) return null;

  return (
    <AnimatePresence>
      {showLetter && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[200] overflow-hidden"
        >
          {!isOpen ? (
            // Closed doors
            <div className="relative w-full h-full cursor-pointer" onClick={handleOpenLetter}>
              {/* Left door */}
              <motion.div
                className="absolute top-0 left-0 w-1/2 h-full bg-gradient-to-r from-sand-100 via-sand-300 to-sand-400 border-r-2 border-sand-500 shadow-2xl"
                whileHover={{ x: -5 }}
                transition={{ duration: 0.3 }}
              />

              {/* Right door */}
              <motion.div
                className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-sand-100 via-sand-300 to-sand-400 border-l-2 border-sand-500 shadow-2xl"
                whileHover={{ x: 5 }}
                transition={{ duration: 0.3 }}
              />

              {/* Seal image */}
              <motion.div
                className="absolute z-30 -translate-x-1/2 -translate-y-1/2"
                style={{ 
                  top: '40%', 
                  left: '30%'
                }}
                animate={{ 
                  rotate: [0, -3, 3, 0],
                  scale: [1, 1.08, 1]
                }}
                transition={{ duration: 3, repeat: Infinity }}
                whileHover={{ scale: 1.15 }}
              >
                <img 
                  src="/pics/sello-intro-oliva.png" 
                  alt="Sello J&R"
                  className="w-40 h-40 md:w-48 md:h-48 object-contain drop-shadow-2xl"
                />
              </motion.div>
            </div>
          ) : (
            // Opening animation - Doors opening
            <div className="relative w-full h-full">
              {/* Left door opening */}
              <motion.div
                className="absolute top-0 left-0 w-1/2 h-full bg-gradient-to-br from-sand-200 to-sand-300 border-r-4 border-sand-400 shadow-2xl origin-left"
                animate={{ 
                  rotateY: [0, -120],
                  x: [0, '-100%'],
                  opacity: [1, 1, 0]
                }}
                transition={{ duration: 4, times: [0, 0.8, 1], ease: "easeInOut" }}
                style={{ transformStyle: 'preserve-3d' }}
              />

              {/* Right door opening */}
              <motion.div
                className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-br from-sand-300 to-sand-200 border-l-4 border-sand-400 shadow-2xl origin-right"
                animate={{ 
                  rotateY: [0, 120],
                  x: [0, '100%'],
                  opacity: [1, 1, 0]
                }}
                transition={{ duration: 3.5, times: [0, 0.8, 1], ease: "easeInOut" }}
                style={{ transformStyle: 'preserve-3d' }}
              />

              {/* Seal breaking and fading */}
              <motion.div
                className="absolute z-30 -translate-x-1/2 -translate-y-1/2"
                style={{ 
                  top: '40%', 
                  left: '30%'
                }}
                animate={{ 
                  scale: [1, 1.3, 0],
                  opacity: [1, 1, 0],
                  rotate: [0, 180]
                }}
                transition={{ duration: 3, ease: "easeInOut" }}
              >
                <img 
                  src="/pics/sello-intro-oliva.png" 
                  alt="Sello J&R"
                  className="w-40 h-40 md:w-48 md:h-48 object-contain drop-shadow-2xl"
                />
              </motion.div>
            </div>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default WelcomeLetter;
